import { useQuery } from "react-query";
import { delivererClient } from "../services/deliverer/DelivererClient";
import moment from "moment";

export const useStockAvailability = (deliveryMoment: string, productIds: string[]) => {
    const deliveryDate = moment(deliveryMoment).isValid() ? moment(deliveryMoment).toISOString() : null;
    
    const { data, isError, isLoading, refetch, isRefetching } = useQuery(
        ['stockAvailability', deliveryDate, productIds],
        async () => {
            if (!deliveryDate || productIds.length === 0) {
                return undefined;
            }

            const request = {
                products: productIds
            };

            const response = await delivererClient.getStockCheckAvailability(
                deliveryDate,
                request
            );

            return response;
        },
        {
            enabled: !!deliveryDate && productIds.length > 0,
            staleTime: 1 * 60 * 1000, // 1 minute
        }
    );

    return { stock: data, isError, isLoading, refetch, isRefetching };
};